<template>
    <section>
        <h1 class="sr-only">Manufacturers</h1>
        <ScrollObserver
            class="absolute top-24"
            @in-viewport="dropdownSeen = false"
            @not-in-viewport="dropdownSeen = true"
        />
        <div class="border-b">
            <Breadcrumbs
                class="block !border-0"
                :crumbs="crumbs"
                h2style="text-base at1024:text-xl"
            />
        </div>
        <Transition name="slide-down">
            <div
                v-if="dropdownSeen"
                class="hidden at1024:flex items-center gap-3 w-full bg-white z-10 fixed top-[var(--header-height)] border-b px-5 py-6 shadow-md"
            >
                <a href="#">
                    <span>
                        <BaseSvg
                            name="icon-expand-less"
                            class="fill-gray-650 hover:fill-red"
                        />
                    </span>
                </a>
                <h2 class="font-bold text-base">{{ $t("Manufacturers") }}</h2>
            </div>
        </Transition>
        <ManufacturerContent
            class="pt-8"
            :manufacturers="manufacturers"
            :tags="tags['vendor-category']"
        />
    </section>
</template>

<script setup>
import {
    BaseSvg,
    Breadcrumbs,
    ManufacturerContent,
    ScrollObserver,
} from "@/Components";
import { ref } from "vue";

defineProps(["crumbs", "manufacturers", "tags"]);

const dropdownSeen = ref(false);
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active,
.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.2s ease-out;
}

.slide-down-leave-to,
.slide-up-enter-from {
    transform: translateY(-100%);
}

.slide-down-enter-from,
.slide-up-leave-to {
    transform: translateY(-100%);
}
</style>
